/******************************************************************************
 *** SysOgnzMng ** 시스템 관리 > 본부 및 지부 관리 * 추가/수정 - 시스템관리자
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import Util from "@/js/common/Util";
import React from "react";

interface Props {
    ognzCd: string; // ""이면 NEW, 값 있으면 EDIT
    upOgnzCdDefault: string; // NEW 시 기본 본부 세팅용(메인 선택값)
    setModalOpen: Function;
    setCallTime: Function;
}

const SysOgnzSaveDialog = ({ ognzCd, upOgnzCdDefault, setModalOpen, setCallTime }: Props) => {
    const [upOgnzCd, setUpOgnzCd] = React.useState<string>(""); // 상위조직(본부)
    const [ognzNm, setOgnzNm] = React.useState<string>(""); // 지부명

  // NEW면 기본 본부 세팅
  React.useEffect(() => {
        if (!Util.isEmpty(ognzCd)) return; // EDIT면 건드리지 않음
        setUpOgnzCd(upOgnzCdDefault || "");
  }, [ognzCd, upOgnzCdDefault]);

    // EDIT면 상세조회
    React.useEffect(() => {
        if (Util.isEmpty(ognzCd)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url: "system/sys/ognz/select-ognz-dtl.do",
            methodType: "post",
            paramType: "json",
            paramData: { ognzCd },
            onSuccessFn: (res: any) => {
                const item = res.result.item;

                setUpOgnzCd(item.upOgnzCd || "");
                setOgnzNm(item.ognzNm || "");

                AppContext.hideSpinner();
            },
        });
    }, [ognzCd]);

    const closeModal = () => {
        setModalOpen(false);
        setCallTime(new Date());
    };

    const handleSave = () => {
        if (Util.isEmpty(upOgnzCd)) {
            AppContext.openAlert({ title: "본부 확인", msg: "본부를 선택해주세요.", icon: "warning" });
            return;
        }
        if (Util.isEmpty(ognzNm)) {
            AppContext.openAlert({ title: "지부명 확인", msg: "지부명을 입력해주세요.", icon: "warning" });
            return;
        }

        const isEdit = !Util.isEmpty(ognzCd);
        const url = isEdit ? "system/sys/ognz/update-ognz.do" : "system/sys/ognz/insert-ognz.do";

        AppContext.openAlert({
            title: isEdit ? "수정" : "등록",
            msg: isEdit ? "수정하시겠습니까?" : "등록하시겠습니까?",
            icon: "warning",
            confirmText: isEdit ? "수정" : "등록",
            handleConfirm: () => {
            AppContext.showSpinner();

            Axios.dataAccess({
                url,
                methodType: "post",
                paramType: "json",
                paramData: {
                    ...(isEdit ? { ognzCd } : {}),
                    upOgnzCd,
                    ognzNm,
                },
                onSuccessFn: () => {
                    AppContext.hideSpinner();

                    AppContext.openAlert({
                        title: (isEdit ? "수정" : "등록") + " 완료",
                        msg: isEdit ? "수정되었습니다." : "등록되었습니다.",
                        icon: "success",
                    });
                    setCallTime(new Date());
                    setModalOpen(false);
                    },
                });
            },
        });
    };

    return (
        <div className="w100p dpFlx jcC">
            <div className="w350">
                {/* 본부 */}
                <div className="dpFlx flxNowrap gap20 jcC">
                    <div className="w320">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">본부 <span className="fcE60000">*</span></span>
                        </div>

                        <SelectBox value={upOgnzCd}
                            width={320} height={36}
                            fontSize={14} maxMenuHeight={150} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={5}
                            background="#fff" paddingRight={8}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="본부 선택"
                            onChangeFunc={(data: string) => setUpOgnzCd(data)}
                        />
                    </div>
                </div>

                {/* 지부명 */}
                <div className="dpFlx flxNowrap gap20 mt10 jcC">
                    <div className="w320">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">지부명 <span className="fcE60000">*</span></span>
                        </div>
                        <TextBox value={ognzNm}
                            width={320} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#BFBFBF" borderOnColor="#222" borderRadius={5}
                            style={{ backgroundColor: "#fff", padding: "0 10px" }}
                            placeholder="지부명을 입력하세요."
                            onChangeFunc={(text: string) => setOgnzNm(text)}
                        />
                    </div>
                </div>

                {/* 버튼 */}
                <div className="dpFlx jcC mt25 gap10 mb20">
                    <Button buttonName="취소"
                        width={100} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                        variant="styCancelBtn"
                        borderRadius={6} buttonClass="dpFlx aiC jcC"
                        onClickFunc={closeModal}
                    />

                    <Button buttonName={Util.isEmpty(ognzCd) ? "등록" : "수정"}
                        width={120} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1} color="#fff"
                        backgroundColor="#007bff" borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={handleSave}
                    />
                </div>
            </div>
        </div>
    );
};

export default SysOgnzSaveDialog;
